import './PressPage.css';

const externalLinkIcon = (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M14 5h5v5" />
    <path d="M10 14L19 5" />
    <path d="M19 13v4a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h4" />
  </svg>
);

function PressPage({ content }) {
  const pressContent = content.press ?? {};
  const section = pressContent.section ?? {};
  const articles = pressContent.articles ?? [];

  return (
    <main className="press-page">
      <section className="section press-section press-section--standalone">
        <div className="container">
          <div className="section-header reveal">
            <h1 className="section-title press-section__title">{section.title}</h1>
            <p className="section-subtitle">{section.subtitle}</p>
          </div>

          <div className="press-grid">
            {articles.map((article, index) => (
              <article
                className={`press-card reveal${index === 0 ? ' press-card--featured' : ''}`}
                style={{ '--delay': `${index * 0.08}s` }}
                key={`${article.title}-${index}`}
              >
                <div className="press-card__media">
                  {article.video ? (
                    <video
                      controls
                      playsInline
                      preload="metadata"
                      aria-label={article.videoLabel}
                    >
                      <source src={article.video} type="video/mp4" />
                      {pressContent.videoFallback}
                    </video>
                  ) : (
                    <img src={article.image} alt={article.imageAlt} loading="lazy" />
                  )}
                  <span className="press-card__badge">{article.outlet}</span>
                </div>

                <div className="press-card__body">
                  <div className="press-card__meta">
                    <span>{article.category}</span>
                    {article.date ? <span>{article.date}</span> : null}
                  </div>
                  <h3>{article.title}</h3>
                  <p>{article.description}</p>
                  <div className="press-card__footer">
                    <span className="press-card__host">{article.hostLabel}</span>
                    {article.href ? (
                      <a
                        className="btn btn-ghost press-card__action"
                        href={article.href}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {pressContent.cardButton}
                        <span className="btn-icon" aria-hidden="true">
                          {externalLinkIcon}
                        </span>
                      </a>
                    ) : null}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default PressPage;
